import MatchGuessSaved from "./MatchGuessSaved.jsx";
import MatchGuessNotSaved from "./MatchGuessNotSaved.jsx";
import MatchGuessSaving from "./MatchGuessSaving.jsx";
import MatchGuessError from "./MatchGuessError.jsx";
import MatchGuessWarning from "./MatchGuessWarning.jsx";

export default function MatchSaveStatus({ status }) {
  const getStatusComponent = (status) => {
    if (typeof status === "undefined" || status === null) {
      status = ""
    }
    status = status.trim()


    switch (status) {
      case "Salvando":
        return <MatchGuessSaving />;
      case "Salvo":
        return <MatchGuessSaved />;
      case "Erro":
        return <MatchGuessError />;
      case "Aviso":
        return <MatchGuessWarning />;
      case "":
        return <MatchGuessNotSaved />;
      default:
        return <></>;
    }
  }

  return (
    <div>
      {getStatusComponent(status)}
    </div>
  )
}
